<template>
  <div class="pa-0 ma-0 fill-height" style="background-color:#f5f5f5" fluid>
    <div>
      <v-container class="fill-height pl-1 pr-0 mx-1 py-2 mt-0" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" class="pt-8">
            <div
              style="max-width:1200px; display: block; margin:auto !important;"
            >
              <p
                style="text-align:center;"
                class="display-1 font-weight-medium"
              >
                Supplier Directory
              </p>
              <p style="text-align:center;" class="body-1 font-weight-normal">
                Supplier profiles offer insights into a specific entity,
                including award trends over time along with the buyers and categories that the supplier provides services to.
              </p>
              <v-row align="start" justify="center" class="align-top-row">
                <v-col cols="6" class="pa-0 ma-0 d-flex align-start">
                  <v-combobox
                      v-model="selectedIndustries"
                      :items="industry_options_formatted"
                      item-text="text"
                      item-value="value"
                      return-object
                      x-small-chips
                      multiple
                      chips
                      deletable-chips
                      :rounded="false"
                      :solo="true"
                      clearable
                      dense
                      outlined
                      label="Industry"
                      x-small
                      :menu-props="{ maxWidth: '400', maxHeight: '400' }"
                      class="pr-2 industry-combobox flex-grow-1"
                      style="min-height: 40px;"
                      @click:clear="clearIndustryFilter()"
                    >
                      <template v-slot:item="{ item }">
                        <v-list-item-content>
                          <v-list-item-title :style="{ paddingLeft: (item.level - 1) * 20 + 'px' }">
                            {{ item.text }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                      <template v-slot:selection="{ attrs, item, select, selected }">
                        <v-chip
                          color="primary"
                          label
                          small
                          v-bind="attrs"
                          :input-value="selected"
                          close
                          @click="select"
                          @click:close="removeIndustry(item)"
                          class="mr-1"
                        >
                          {{ item.text }}
                        </v-chip>
                      </template>
                  </v-combobox>
                </v-col>
                <v-col cols="6" style="max-width:800px;" class="pa-0 ma-0 d-flex align-start">
                  <div class="flex-grow-1" style="min-height: 40px;">
                    <supplier-search :rounded="false" :color="'#f5f5f5'" :dark="false" :solo="true" @clearFilter="reset_filters" @search="handleSearch" />
                  </div>
                </v-col>
                <!-- No extra Search button; SupplierSearch handles triggering searches -->
                
              </v-row>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" class="pt-0 mb-0 pb-0 pr-0">
            <supplier-table ref="supplierTable" />
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import SupplierSearch from "../components/SupplierSearch";
import SupplierTable from "../components/entities/SupplierTable";
//import EntityProfile from "../components/entities/EntityProfile";

import { fetchIndustries } from "../components/APIManager";

export default {
  components: {
    SupplierSearch,
    SupplierTable
  },
  props: {
    publisher: {}
  },
  data() {
    return {
      selectedIndustries: [],
      search: { publisher_id: Number },
      current_entity: {},
      global_search: false,
      view_index: null,
      industry_options: [],
      industry_options_formatted: [],
      pendingIndustries: [],

      selected: "snapshot",
      current_view: "snapshot",
      watching: false,
      filters: {}
      //results_drawer: null
    };
  },

  created() {

  },

  mounted() {
    var query = this.$route.query;
    
    // Load industries (nested structure) and format for hierarchical display
    fetchIndustries().then(data => {
      if (data && Array.isArray(data)) {
        this.industry_options = data;
        // Format for combobox with hierarchical structure
        this.formatIndustriesForCombobox(data);
        
        // Check if industry_id is in query (support both single and multiple)
        if (query.hasOwnProperty("industry_id")) {
          const industryIds = Array.isArray(query["industry_id"]) 
            ? query["industry_id"] 
            : [query["industry_id"]];
          this.findIndustryById(industryIds, data);
        }
      } else {
        //console.error("Invalid industries data:", data);
      }
    }).catch(error => {
      //console.error("Error loading industries:", error);
    });
    
  },

  methods: {
    formatIndustriesForCombobox(industries, level = 1) {
      // Flatten nested structure with level information
      const flatten = (items, currentLevel = 1) => {
        let result = [];
        items.forEach(item => {
          result.push({
            text: item.name,
            value: item.id,
            level: currentLevel,
            parent_id: item.parent_id || null
          });
          if (item.children && item.children.length > 0) {
            result = result.concat(flatten(item.children, currentLevel + 1));
          }
        });
        return result;
      };
      this.industry_options_formatted = flatten(industries);
    },

    findIndustryById(industryIds, industries) {
      // Accept single id or array
      const ids = Array.isArray(industryIds) ? industryIds : [industryIds];

      // Recursively collect matches by ID in nested structure
      const collect = (items, out) => {
        items.forEach(item => {
          if (ids.includes(item.id) || ids.includes(String(item.id))) {
            out.push({ text: item.name, value: item.id, level: item.level });
          }
          if (item.children && item.children.length > 0) {
            collect(item.children, out);
          }
        });
      };

      const results = [];
      collect(industries, results);
      this.selectedIndustries = results;
      this.pendingIndustries = [...results];
    },

    removeIndustry(industry) {
      const index = this.selectedIndustries.findIndex(ind => ind.value === industry.value);
      if (index > -1) {
        this.selectedIndustries.splice(index, 1);
        this.pendingIndustries = [...this.selectedIndustries];
      }
    },

    clearSearch(){
      var qry = JSON.parse(JSON.stringify(this.$route.query));
      delete qry["page"];
      var page_num = 1;
      this.$router.push({ query: qry});
    },

    process_route() {
      this.filters = this.$route.query;
    },

    clearIndustryFilter(){
      this.selectedIndustries = [];
      this.pendingIndustries = [];
    },

    isEmpty(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },

    reset_filters(){
      var qry = JSON.parse(JSON.stringify(this.$route.query));
      delete qry["term"];
      delete qry["page"];
      this.$router.push({ query: qry });
    },

    handleSearch(queryFromSearch) {
      // Called when SupplierSearch triggers a search
      // Merge industries into the query and ensure reload happens
      const newQuery = JSON.parse(JSON.stringify(queryFromSearch));

      // Merge industries - support multiple industries
      const industries = this.selectedIndustries && this.selectedIndustries.length > 0
        ? this.selectedIndustries.map(i => i.value)
        : null;
      
      if (industries) {
        newQuery["industry_id"] = industries;
      } else {
        delete newQuery["industry_id"];
      }

      // Remove tag filter from query if present
      delete newQuery["tag"];

      // Update route with merged query
      this.$router.replace({ name: this.$route.name, query: newQuery }).catch(err => {
        // Ignore navigation duplicated errors - we'll still reload below
        if (err.name !== 'NavigationDuplicated') {
          //console.error(err);
        }
      });

      // Always trigger SupplierTable reload immediately
      // This ensures reload happens even if route navigation fails
      if (this.$refs.supplierTable) {
        this.$nextTick(() => {
          this.$refs.supplierTable.buildQuery();
        });
      }
    }
  },

  computed: {
    hasFilters() {
      // Check if any filters are set (for UX, though SupplierSearch triggers search)
      return (this.selectedIndustries && this.selectedIndustries.length > 0);
    }
  },

  watch: {
    selectedIndustries(newVal) {
      // Update pending industries when selection changes
      this.pendingIndustries = [...newVal];
    },

    // Merge filters into route when SupplierSearch triggers a search (route change)
    $route(to, from) {
      // Only merge filters if this is a new route change (not from initial mount)
      if (!from || !from.name) {
        return; // Skip on initial mount
      }

      // When SupplierSearch updates the route (adds term/page), merge current filters
      const currentQuery = JSON.parse(JSON.stringify(this.$route.query));
      const newQuery = JSON.parse(JSON.stringify(currentQuery));

      // Merge industries - support multiple industries
      const industries = this.selectedIndustries && this.selectedIndustries.length > 0
        ? this.selectedIndustries.map(i => i.value)
        : null;
      
      if (industries) {
        newQuery["industry_id"] = industries;
      } else {
        delete newQuery["industry_id"];
      }

      // Remove tag filter from query if present (tags are now searched via keywords)
      delete newQuery["tag"];

      // Normalize query values for comparison - convert single values to arrays and sort
      const normalizeArrayValue = (value) => {
        if (value === undefined || value === null) return undefined;
        if (!Array.isArray(value)) return [value].sort();
        return [...value].sort();
      };
      
      const normalizeQuery = (q) => {
        const normalized = { ...q };
        // Normalize arrays, handling both single values and arrays
        if (normalized.industry_id !== undefined) {
          normalized.industry_id = normalizeArrayValue(normalized.industry_id);
        }
        // Also normalize term for comparison
        if (normalized.term !== undefined) {
          normalized.term = normalizeArrayValue(normalized.term);
        }
        return normalized;
      };
      
      // Normalize both queries for comparison
      const normalizedNewQuery = normalizeQuery(newQuery);
      const normalizedRouteQuery = normalizeQuery(this.$route.query);
      
      // Compare normalized queries - check if ANY field changed
      const queriesAreEqual = JSON.stringify(normalizedNewQuery) === JSON.stringify(normalizedRouteQuery);
      
      // Update the route if query changed (but don't fail if navigation is duplicated)
      if (!queriesAreEqual) {
        // Use replace to update query - catch and ignore NavigationDuplicated errors
        this.$router.replace({ name: this.$route.name, query: newQuery }).catch(err => {
          // Silently ignore navigation duplicated errors - we'll still reload below
          if (err.name !== 'NavigationDuplicated') {
            //console.error(err);
          }
        });
      }
      
      // Always trigger SupplierTable reload to ensure filters are applied
      // This is critical - ensures reload happens even if route navigation fails
      if (this.$refs.supplierTable) {
        this.$nextTick(() => {
          this.$refs.supplierTable.buildQuery();
        });
      }
    }
  }
};
</script>
<style scoped>
.v-input {
    font-size: 14px !important;
}

.search-button {
    height: 40px !important;
    min-width: 100px;
}

/* Align comboboxes at top - maintain alignment even when chips are added */
.align-top-row {
    align-items: flex-start !important;
}

.industry-combobox >>> .v-input__control,
.supplier-search-wrapper >>> .search-combobox >>> .v-input__control {
    min-height: 40px;
}

.industry-combobox >>> .v-input__slot,
.supplier-search-wrapper >>> .search-combobox >>> .v-input__slot {
    min-height: 40px;
    align-items: flex-start;
    padding-top: 4px;
}
</style>
